import { Checkbox, FormControlLabel } from '@mui/material';
import { useIntl } from 'react-intl';

import type { Annotation } from '../../types/responseTypes';

interface SupportedIndirectlyCheckboxProps {
  attribute: {
    name: string;
    supportedIndirectly?: boolean;
  };
  annotation: Annotation | null;
  disabled?: boolean;
  onChange: (attributeName: string, payload: { supportedIndirectly: boolean }) => void;
}

export const SupportedIndirectlyCheckbox = ({
  attribute,
  annotation,
  disabled = false,
  onChange,
}: SupportedIndirectlyCheckboxProps) => {
  const { formatMessage } = useIntl();
  const checkboxId =
    attribute.name + (annotation?.annotationId || 'new') + '-supported-indirectly-checkbox';

  return (
    <FormControlLabel
      sx={{
        margin: 0,
        '& .MuiFormControlLabel-label': {
          fontSize: 14,
        },
      }}
      control={
        <Checkbox
          id={checkboxId}
          checked={attribute.supportedIndirectly || false}
          onChange={(e) =>
            onChange(attribute.name, {
              supportedIndirectly: e.target.checked,
            })
          }
          disabled={disabled}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 18,
              width: 18,
              height: 18,
            },
          }}
        />
      }
      label={formatMessage({ id: 'annotationContent.annotationConfig.supportedIndirectly.label' })}
    />
  );
};
